<div class="chip-list d-flex flex-wrap" [attr.yp-e2e-id]="options.e2eId">
  <div class="chip-item d-flex m-1 p-1 align-items-center" [ngClass]="{'disabled' : item.disabled}" *ngFor="let item of chipItems">
    <p>{{item.label}}</p>
    <i class="fa fa-times"
       [attr.yp-e2e-id]="item.e2eId || null"
       (click)="deleteChip(item)">
    </i>
  </div>
</div>
